export const GET_COUPONS = "GET_COUPONS";
export const GET_COUPON_BY_ID = "GET_COUPON_BY_ID";
export const UPDATE_COUPON = "UPDATE_COUPON";
export const DELETE_COUPON = "DELETE_COUPON";
export const CREATE_COUPON = "CREATE_COUPON";
export const ADD_COUPON_GOOD = "ADD_COUPON_GOOD";
export const DELETE_COUPON_GOOD = "DELETE_COUPON_GOOD";
export const UPDATE_COUPON_GOOD = "UPDATE_COUPON_GOOD";
